import {
  computed,
  onUnmounted,
  useContext,
  useStore,
} from '@nuxtjs/composition-api'

export function useGetYmClientId() {
  const ctx = useContext()
  const YM_ID = ctx.$config.YM_ID
  const store = useStore()
  const ymClientId = computed(() => {
    return store.getters['ym/GET_YM_CLIENT_ID']
  })

  let timeoutId = null

  const fetchYmClientId = () => {
    return new Promise((resolve) => {
      let isSuccess = false
      try {
        window.ym(YM_ID, 'getClientID', (value) => {
          isSuccess = typeof value === 'string' && !!value
          resolve(value)
        })
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => {
          if (!isSuccess) {
            console.error('ERROR GET YM CLIENT ID TIMEOUT')
          }
          resolve(null)
        }, 3000)
      } catch (e) {
        console.error('ERROR GET YM CLIENT ID:', e)
        resolve(null)
      }
    })
  }

  const getYmClientId = async () => {
    if (ymClientId.value === null) {
      const response = await fetchYmClientId()
      store.commit('ym/SET_YM_CLIENT_ID', response)
      return response
    }
    return ymClientId.value
  }

  return { getYmClientId }
}
